import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";

export const EmailTemplatesEffectActions = {
  previewInviteTemplate: `${Entities.EmailTemplates}_previewInviteTemplate`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.EmailTemplates,
  initSchema,
  aliasName: DIContainerKeys.EmailTemplatesService,
})
export class EmailTemplatesService extends HttpService {
  @loader(Loaders.PreviewInviteTemplateLoader)
  @flagger(Flaggers.PreviewInviteTemplateFlagger)
  @action(DIContainerKeys.EmailTemplatesService)
  public *previewInviteTemplate(): Generator<any, void, any> {
    
  }
}

